import { useSnackbar } from 'notistack';
import { ChangeEvent, Dispatch, useEffect, useRef, useState } from 'react';
import { TSelectItem } from '../../../../types/common';
import { checkResData } from '../../../../utils/common';
import { UseFormReset, UseFormSetValue } from 'react-hook-form';
import { SITE_TASK_ORDER_TYPE } from '../../../../const/ProcessConst';
import { createSiteTask } from '../../../../apicalls/task';
import {
  convertFormDateToApiDate,
  createSiteProcessAndSiteTaskEmployeeList
} from '../../../../utils';
import {
  createSiteTaskFormMerchandiseOrderList,
  createSiteTaskFormOutSourceOrderList,
  createSiteTaskFormProcessListPulldown
} from '../../../../utils';
import { TAddSiteTaskForm } from '../../../../types/task';
import { SITE_TASK_FORM_ORDER_TYPE_LIST } from '../../../../const/TaskConst';

export type Props = {
  setIsOpen: Dispatch<boolean>;
  afterSubmit: () => void;
  constructId: number;
  setValue: UseFormSetValue<any>;
  reset: UseFormReset<any>;
  isOpen: boolean;
  siteProcessId?: number;
};

export const useHooks = (props: Props) => {
  const {
    setIsOpen,
    afterSubmit,
    constructId,
    siteProcessId,
    setValue,
    reset,
    isOpen
  } = props;

  // 送信可能フラグ 多重送信対策
  const isSubmitable = useRef(false);

  const submit = (form: TAddSiteTaskForm) => {
    if (!isSubmitable.current) return;

    isSubmitable.current = false;
    createSiteTask(
      form.site_process_id.value,
      form.site_task_name,
      form.charge_user_id.value,
      convertFormDateToApiDate(form.planned_end_date),
      form.detail,
      Number(form.order_type),
      form.order_id.value
    ).then((resData: any) => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        if (data) {
          setIsOpen(false);
          afterSubmit();
        } else {
          isSubmitable.current = true;
        }
      });
    });
  };

  // 工程選択リスト
  const [siteProcessList, setSiteProcessList] = useState<TSelectItem[]>([]);

  // 担当者選択リスト
  const [employeeList, setEmployeeList] = useState<TSelectItem[]>([]);

  // 発注書リスト
  const [purchaseOrderList, setPurchaseOrderList] = useState<TSelectItem[]>([]);

  // 外注発注書リスト
  const [outsourcesOrderList, setOutsourcesOrderList] = useState<TSelectItem[]>(
    []
  );

  // 商品発注書リスト
  const [merchandiseOrderList, setMerchandiseOrderList] = useState<
    TSelectItem[]
  >([]);

  // 発注書区分変更時のハンドラ
  const handleChangeOrderTypeRadio = (e: ChangeEvent<HTMLInputElement>) => {
    const currentValue = e.target.value;
    // formの発注書区分設定値を更新
    setValue('order_type', currentValue);

    // 発注書区分によって発注書プルダウンの内容を切り替え
    const orderList =
      currentValue === SITE_TASK_ORDER_TYPE.outsources
        ? outsourcesOrderList
        : merchandiseOrderList;
    setPurchaseOrderList(orderList);

    // 初期値をセット
    setValue('order_id', { value: 0, label: '--' });
  };

  // キャンセル時の処理
  const cancelSubmit = () => {
    setIsOpen(false);
  };

  // snackbar
  const { enqueueSnackbar } = useSnackbar();

  // 初回レンダリング時の処理。各セレクトボックスの内容を設定
  useEffect(() => {
    createSiteTaskFormProcessListPulldown(constructId, enqueueSnackbar).then(
      list => {
        setSiteProcessList(list);
      }
    );
    createSiteTaskFormOutSourceOrderList(enqueueSnackbar).then(list => {
      setOutsourcesOrderList(list);
      setPurchaseOrderList(list);
    });
    createSiteTaskFormMerchandiseOrderList(enqueueSnackbar).then(list => {
      setMerchandiseOrderList(list);
    });
    createSiteProcessAndSiteTaskEmployeeList(constructId, enqueueSnackbar).then(
      employeeList => {
        setEmployeeList(employeeList);
      }
    );
  }, []);

  // 初期値セット
  useEffect(() => {
    reset({
      site_process_id: siteProcessId
        ? siteProcessList.find(item => item.value === siteProcessId)
        : {
            value: 0,
            label: '--'
          },
      site_task_name: null,
      charge_user_id: { value: 0, label: '--' },
      end_date: null,
      detail: null,
      order_type: SITE_TASK_FORM_ORDER_TYPE_LIST[0].value,
      order_id: { value: 0, label: '--' }
    });
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      isSubmitable.current = true;
    }
  }, [isOpen]);

  return {
    submit,
    cancelSubmit,
    handleChangeOrderTypeRadio,
    siteProcessList,
    purchaseOrderList,
    employeeList
  };
};
